import ChevronRightIcon from "@/assets/icons/chevron-right.svg";
import { cx } from "@/utils";
import {
  DropdownMenuSubTriggerProps,
  SubTrigger,
} from "@radix-ui/react-dropdown-menu";

import styles from "./Dropdown.module.css";

/**
 * DropdownSubTrigger
 * Container for the DropdownItems
 */

const DropdownSubTrigger: React.FunctionComponent<
  DropdownMenuSubTriggerProps
> = ({ children, className, ...props }) => {
  return (
    <SubTrigger className={cx(styles.base, styles.item, className)} {...props}>
      {children}
      <ChevronRightIcon className={styles.endIcon} />
    </SubTrigger>
  );
};

export default DropdownSubTrigger;
